import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { CommissionDto, PartnerDto, PaymentMode, TransactionType } from '../api/models';
import { CommissionCtlService, PartnerCtlService, PaymentModeCtlService, TransactionCtlService } from '../api/services';
import { SessionService } from '../common/session.service';
import { environment } from '../../environments/environment';
import { MessageService } from '../common/message.service';
import * as bootstrap from 'bootstrap';
import { constants } from '../common/constants';

@Component({
    selector: 'app-commission',
    imports: [
    ReactiveFormsModule
],
    templateUrl: './commission.component.html',
    styleUrl: './commission.component.css'
})
export class CommissionComponent implements OnInit{


  isAddCommission:boolean=false;
  addCommForm:FormGroup;
  partners?:Array<PartnerDto>;
  trxTypes?:Array<TransactionType>;
  paymentModes=constants.PaymentModes;
  paymentNetworks?:Array<PaymentMode>;
  commissions?:Array<CommissionDto>;
  currentComm?:CommissionDto;
  isPayedByCustomer=false;
  connectedUser?:any;

  constructor(private formBuilder:FormBuilder,
    
    private partnerService:PartnerCtlService,
    private trxService:TransactionCtlService,
    private session: SessionService,
    private commissionService:CommissionCtlService,
    private messageService:MessageService,
    private paymentModService:PaymentModeCtlService
  ){
    this.addCommForm = this.formBuilder.group({
      idCommission:[''],
      partnerType:[''],
      partner:['',[Validators.required]],
      paymentMode: ['',Validators.required],
      paymentNetwork: ['',Validators.required],
      flatAmount:['',[Validators.required,Validators.min(0)]],
      amount: ['',[Validators.required,Validators.min(0)]],
      type:['',Validators.required],
      payedByCustomer:[''],
      limitInf:['',[Validators.min(0),Validators.required]],
      limitSup:['',[Validators.min(0),Validators.required]],
      transactionType:['',[Validators.required]]
    });
  }
  ngOnInit(): void {
    this.connectedUser = this.session.getSessionInfo();
    this.addCommForm.controls['partnerType'].setValue('MERCHANT');
    this.loadPartners();
    this.loadTransactionTypes();
  }

  onAddCommission(){
    let form =this.addCommForm.value;
    let partnerType = form.partnerType;
    let dto:CommissionDto ={
      amount:form.amount,
      flatAmount:form.flatAmount,
      limitInf: form.limitInf,
      limitSup: form.limitSup,
      type:form.type,
      transactionType : {
        code: form.transactionType
      },
      partner: {
        id:form.partner as number,
        name:'',
        phone:'',
        address:''
      },
      paymentMode:{
        code: form.paymentNetwork
      },
      payedByCustomer: this.isPayedByCustomer
    };
    console.log(dto);
    
    if(form.idCommission){
      dto.id = form.idCommission;
      this.commissionService.updateCommission(
        dto
      ).subscribe({
        next:()=>{
          this.addCommForm.reset();
          this.addCommForm.controls['partnerType'].setValue(partnerType);
          this.loadPartners();
          this.addCommForm.controls['partner'].setValue(dto.partner.id);
          this.loadCommissions();
          this.isAddCommission =false
          this.messageService.showMessage('Commission modifiée avec succés','toastMessage');
  
        }
      });
    }else{
    this.commissionService.createCommission(
      dto).subscribe({
      next:()=>{
        this.addCommForm.reset();
        this.addCommForm.controls['partnerType'].setValue(partnerType);
        this.loadPartners();
        this.addCommForm.controls['partner'].setValue(dto.partner.id);
        this.loadCommissions();
        this.isAddCommission =false
        this.messageService.showMessage('Commission ajoutée avec succés','toastMessage');

      }
    });
  }

  }
  loadPartners(){
    let partner = this.session.getSessionInfo().partner?.id!!;
    this.partnerService.getChildren(
       partner,
      this.addCommForm.value.partnerType
      
    ).subscribe({
      next:(resp)=>{
        this.partners = resp.content
      }
    });

  }
  
  loadTransactionTypes(){
    this.trxService.getTransactionTypes().subscribe({
      next:(resp)=>{
        this.trxTypes =resp;
      }
    })

  }
  loadCommissions(){

    let idPartner= this.addCommForm.value.partner!!;
    this.commissionService.getCommission(
      idPartner
    ).subscribe({
      next:(resp)=>{
        this.commissions=resp;
      }
    })
  }
  commissionDetails(comm:CommissionDto){
    
         this.commissionService.getDetailsCommission(
          comm.id!!
         ).subscribe({
          next:(resp)=> {
            this.currentComm = resp;
            const modAdd = new bootstrap.Modal('#detailsCommission',{});
            modAdd.show();
          }
         });
  }
  editCommission(comm:CommissionDto){
    this.commissionService.getDetailsCommission(
      comm.id!!
     ).subscribe({
      next:(resp)=> {
        this.currentComm = resp;
        this.addCommForm.controls['amount'].setValue(resp.amount);
        this.addCommForm.controls['flatAmount'].setValue(resp.flatAmount);
        this.addCommForm.controls['type'].setValue(resp.type);
        this.addCommForm.controls['limitInf'].setValue(resp.limitInf);
        this.addCommForm.controls['limitSup'].setValue(resp.limitSup);
        this.addCommForm.controls['paymentMode'].setValue(resp.paymentMode?.paymentMode);
        this.loadPaymentModes();
        this.addCommForm.controls['partnerType'].setValue(resp.partner?.type);
        this.addCommForm.controls['partner'].setValue(resp.partner?.id);
        this.addCommForm.controls['payedByCustomer'].setValue(resp.payedByCustomer);
        this.addCommForm.controls['transactionType'].setValue(resp.transactionType?.code);
        this.addCommForm.controls['idCommission'].setValue(resp.id);
        this.isPayedByCustomer=resp.payedByCustomer!!;
        console.log("isPayed "+this.isPayedByCustomer)
        
       this.isAddCommission = true;
      }
     });
  }
  loadPaymentModes(){
    console.log(this.addCommForm.value.paymentMode);
    console.log(this.addCommForm.value.paymentMode?.length);
    if(this.addCommForm.value.paymentMode.length>0){
    this.paymentModService.getPaymentMode(
      this.addCommForm.value.paymentMode
    ).subscribe({
      next:(resp)=>{
        this.paymentNetworks =resp;
        if(this.currentComm?.paymentMode){
        this.addCommForm.controls['paymentNetwork'].setValue(this.currentComm.paymentMode.code);
      }
        
      }
    });
  }
  }
  switchScreen(){
    
    this.isPayedByCustomer =false;
    this.isAddCommission =!this.isAddCommission;
  }
  onPayedByCustomer(event:any){

    this.isPayedByCustomer =event.target.checked;
    console.log(this.isPayedByCustomer);

  }

}
